import React, { CSSProperties } from "react";
import "./styles.scss";

type ButtonProps = React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

interface Props extends ButtonProps {
  text: string;
  typeBtn?: "default" | "transparent" | "red";
  style?: CSSProperties | undefined;
}

const Button = ({ text, style, typeBtn = "default", ...restProps }: Props) => {
  return (
    <button
      {...restProps}
      style={style}
      className={
        typeBtn === "default"
          ? "btn-default"
          : typeBtn === "transparent"
          ? "btn-transparent"
          : typeBtn === "red"
          ? "btn-red"
          : ""
      }>
      {text}
    </button>
  );
};

export default Button;
